import { Injectable } from '@angular/core';

import { RidangoReduxAction } from '@ridango/core';

import { HistoryPeriod } from '../model/validation-history.model';

@Injectable()
export class ValidationHistoryActions {
    static FETCH_VALIDATION_HISTORY = '[ValidationHistory]: Fetch start';
    static FETCH_VALIDATION_HISTORY_SUCCESS = '[ValidationHistory]: Fetch success';
    static FETCH_VALIDATION_HISTORY_ERROR = '[ValidationHistory]: Fetch error';

    static SET_START_DATE = '[ValidationHistory]: Set start date';
    static SET_END_DATE = '[ValidationHistory]: Set end date';

    fetchValidationHistory(payload: HistoryPeriod): RidangoReduxAction {
        return {
            type: ValidationHistoryActions.FETCH_VALIDATION_HISTORY,
            payload: payload,
        };
    }

    fetchValidationHistorySuccess(payload: any): RidangoReduxAction {
        return {
            type: ValidationHistoryActions.FETCH_VALIDATION_HISTORY_SUCCESS,
            payload: payload,
        };
    }

    fetchValidationHistoryFail(error: any): RidangoReduxAction {
        return {
            type: ValidationHistoryActions.FETCH_VALIDATION_HISTORY_ERROR,
            payload: error,
        };
    }

    setStartDate(payload: Date): RidangoReduxAction {
        return {
            type: ValidationHistoryActions.SET_START_DATE,
            payload: payload,
        };
    }

    setEndDate(payload: Date): RidangoReduxAction {
        return {
            type: ValidationHistoryActions.SET_END_DATE,
            payload: payload,
        };
    }
}
